import gql from 'graphql-tag';

export const bulkAssignTaskTeamsMutation = gql`
  mutation bulkAssignTaskTeams(
    $taskIds: [String!]!
    $assigneeGroups: [String!]!
  ) {
    bulkAssignTaskTeams(
      taskIds: $taskIds
      assigneeGroups: $assigneeGroups
    ) {
      successCount
      failureCount
      failures {
        taskId
        reason
      }
    }
  }
`;

